import React from "react";
import StepPageHeader from "../../UI/StepPageHeader/StepPageHeader";
import profileBanner from "../../../assets/icons/profileBanner.jpeg";
import ProfileForm from "../ProfileForm/ProfileForm";
import "./ProfileHome.scss";
import GlobalStore from "../../store/globalStore";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import { DropOffLogAPI } from "../../Services/dashboard/docVerificationAPIServices";
import NonIndividualProfile from "../ProfileForm/NonIndividualProfile";
import ProfileFormJoint from "../ProfileForm/ProfileJoint";
import { usePageTitle } from '../../../hooks/usePageTitle';

export interface ProfileHomeProps { }

const ProfileHome: React.FC<ProfileHomeProps> = (props) => {
  usePageTitle('Profile');
  const dropOffObj = () => {
    let userId = 0;
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = parseInt(tokenMainObj?.UserId?.toString());
    }
    const stageInfoObj = {
      applicationid: GlobalStore?.applicationID,
      accountCagtegory: GlobalStore?.stageStatus?.accountcategory
        ? GlobalStore?.stageStatus?.accountcategory
        : GlobalStore?.accountcategory,
      stageOrderId: 14,
      userId: userId?.toString(),
      rmAssisted: GlobalStore?.stageStatus?.rmassisted,
    };
    DropOffLogAPI(() => { }, stageInfoObj);
  };
  React.useEffect(() => {
    dropOffObj();
    window.sessionStorage.setItem("stageInfoId", "1");
  }, []);

  return (
    <div className="prflHome">
      <StepPageHeader title="Profile" />
      <div className="banner">
        <img className="bannerImg" src={profileBanner} alt="" aria-hidden="true" />
      </div>
      {
        GlobalStore.entityType == "NONINDIVIDUAL" ?
          <NonIndividualProfile />
          : GlobalStore.entitySubType == "Joint" ?
            <ProfileFormJoint /> :
            <ProfileForm />
      }
    </div>
  );
};

export default ProfileHome;
